/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Play_PreviewInputs */



/**
* | output |
* | --- |
* | "Toggle Play Preview" |
*
* @param {Shortcut_Keys_Name_Toggle_Play_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_play_preview = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Play_PreviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Play_PreviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer l'apercu de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau abspielen/einschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva l'anteprima di riproduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить/Выключить предварительный просмотр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar la vista previa de reproducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换播放预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューの再生を切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्ले प्रीव्यू टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar reprodução Pré-visualização")
	return /** @type {LocalizedString} */ ("Toggle Play Preview")
});